module.exports = __webpack_public_path__ + "static/media/github.121398c0.svg";